import { Outlet, useParams } from "react-router-dom-v5-compat";

import { useFetchMenu } from "@onsite_app/MobileOrderingMenu/queries";

import { TitleBar } from "../../Atoms";

export const SectionLayout = () => {
  const menu = useFetchMenu();
  const { sectionUuid } = useParams();
  const section = menu.sections.find((s) => s.uuid == sectionUuid);
  if (!section) {
    return <div>No Section </div>;
  }
  return (
    <div>
      <div className="hidden md:block">
        <TitleBar>
          <div className="md:text-4xl md:font-bold">{section.name}</div>
        </TitleBar>
      </div>

      <div className="">
        <Outlet />
      </div>
    </div>
  );
};
